import { uuid25 } from "../../../uuid/dist/uuid25.js";
import { query } from "../../../erd-editor-schema/dist/query/index.js";
import { addIndexAction, changeIndexUniqueAction } from "./atom.actions.js";
//#region src/engine/modules/index/generator.actions.ts
var addIndexAction$ = (tableId) => function* () {
	yield addIndexAction({
		id: uuid25(),
		tableId
	});
};
var changeIndexUniqueAction$ = (indexId) => function* ({ collections }) {
	const index = query(collections).collection("indexEntities").selectById(indexId);
	if (!index) return;
	yield changeIndexUniqueAction({
		id: indexId,
		tableId: index.tableId,
		value: !index.unique
	});
};
var actions$ = {
	addIndexAction$,
	changeIndexUniqueAction$
};
//#endregion
export { actions$, addIndexAction$, changeIndexUniqueAction$ };
